import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'

export default async function dashboard (state) {
  const Dashboard = (await import(/* webpackChunkName: 'component-dashboard' */ '../../components/dashboard')).default
  const { role, mode, options } = store.getState()[appSlice.name]
  const { user } = store.getState()[profileSlice.name]

  const showRemote = role !== 'slideware' && mode !== 'integration'

  return new Dashboard({
    user: state.get('user'),
    showRemote,
    showPollEvRemote: user.features.alpha_tester,
    showPresenterControls: user.features.alpha_tester,
    allowRedirects: options.allowRedirects,
    mode,
    state
  })
}
